import React, { useContext } from 'react';
import { Grid, Container, Typography } from '@mui/material';
import Footer from './Footer.styled';
import PrimaryNav from './PrimaryNav';
import SocialNav from './SocialNav';
import SecondaryNav from './SecondaryNav';
import styles from './styles';
import ScrollToTop from './ScrollToTop';
import RootContext from '../../../util/root.context';

const EirFooter = ({ cmsFooterData }) => {
  const { state } = useContext(RootContext);

  return state.enableFooter ? (
    <Footer id='footer'>
      {/* footer contianer */}

      <Container maxWidth='lg' sx={styles.containerStyle}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ScrollToTop style={styles.scrollTop} />
          </Grid>
          {/* primary navs */}
          <Grid item xs={12}>
            <PrimaryNav
              data={cmsFooterData?.attributes?.PrimaryNav}
              styles={styles.primaryNavStyle}
            />
          </Grid>
          {/* social links */}
          <Grid item xs={12}>
            <SocialNav data={cmsFooterData?.attributes} />
          </Grid>
          {/* secondary navs */}
          <Grid item container justifyContent='center' xs={12}>
            <SecondaryNav
              data={cmsFooterData?.attributes?.SecondaryNav}
              styles={styles.secondaryNavStyle}
            />
          </Grid>

          {/* disclaimer */}
          {/* TODO styles */}
          <Grid item xs={12}>
            <Typography
              variant='subtitle1'
              dangerouslySetInnerHTML={{ __html: cmsFooterData?.attributes?.Disclaimer }}
              sx={styles.disclaimerStyle}
            />
          </Grid>
        </Grid>
      </Container>
    </Footer>
  ) : (
    ''
  );
};

export default EirFooter;
